function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { getDefaultFormState } from "../../Schema/utils";
export const getLocalizedStringFormData = props => {
  const schema = props.schema,
        formData = props.formData,
        registry = props.registry;
  const _registry$formContext = registry.formContext,
        languages = _registry$formContext.languages,
        currentLocale = _registry$formContext.currentLocale;
  let newFormData = {};

  if (typeof formData === "string") {
    let defaultValue = formData;
    languages.map(locale => {
      const localeId = "locale:" + locale;
      const value = currentLocale === locale && defaultValue;
      newFormData[localeId] = value || "";
    });
  } else {
    languages.map(locale => {
      const localeId = "locale:" + locale;
      const value = formData && formData[localeId];
      newFormData[localeId] = value || "";
    });
  }

  return getDefaultFormState(schema, _extends({}, newFormData));
};
export default getLocalizedStringFormData;